import EscolaridadService from "@/api/services/personal/nomencladores/EscolaridadService"
import Vue from "vue"

const state = () => ({
    escolaridades: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    ESCOLARIDADES: state => {
        return state.escolaridades
    },
    ESCOLARIDADES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_ESCOLARIDADES: (state, payload) => {
        state.escolaridades = payload
    },

    SET_ESCOLARIDADES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ESCOLARIDAD: (state, payload) => {
        state.escolaridades.push(payload)
    },

    UPDATE_ESCOLARIDAD: (state, payload) => {
        state.escolaridades = state.escolaridades.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_ESCOLARIDAD: (state, payload) => {
        state.escolaridades = state.escolaridades.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_ESCOLARIDADES: async ({ commit, state }, { filter, escolaridadEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await EscolaridadService.get({ filter, escolaridadEstado, ...pagination })
            if (status === 200) {
                commit("SET_ESCOLARIDADES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las escolaridades, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_ESCOLARIDADES: async ({ commit }) => {
        try {
            let { data, status } = await EscolaridadService.getAll()
            if (status === 200) {
                commit("SET_ESCOLARIDADES", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_ESCOLARIDADES: async ({ commit }) => {
        try {
            let { data, status } = await EscolaridadService.getAllRecords()
            if (status === 200) {
                commit("SET_ESCOLARIDADES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las escolaridades, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ESCOLARIDAD: async ({ commit }, payload) => {
        try {
            let { data, status } = await EscolaridadService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_ESCOLARIDAD", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la escolaridad, inténtelo nuevamente"
            })
        }
    },

    ADD_ESCOLARIDAD: async ({ commit }, payload) => {
        try {
            let { data, status } = await EscolaridadService.post(payload)
            if (status === 201) {
                commit("ADD_ESCOLARIDAD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La escolaridad ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la escolaridad, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_ESCOLARIDAD: async ({ commit }, payload) => {
        try {
            let { data, status } = await EscolaridadService.put(payload)
            if (status === 200) {
                commit("UPDATE_ESCOLARIDAD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La escolaridad ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la escolaridad, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_ESCOLARIDAD: async ({ commit }, payload) => {
        try {
            let { status, data } = await EscolaridadService.delete(payload)
            if (status === 204) {
                commit("DELETE_ESCOLARIDAD", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La escolaridad ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_ESCOLARIDAD", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La escolaridad ha sido deshabiltada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la escolaridad, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
